import { ListItemText, ListItemTextProps } from '@mui/material';

interface LastValueListItemTextProps extends Omit<ListItemTextProps, 'primary'> {
  currentValue: number | null | undefined;
  lastValue: number | null | undefined;
}

export const LastValueListItemText = ({ currentValue, lastValue, ...props }: LastValueListItemTextProps) => {
  const isUsingLastValue = !currentValue;
  const displayValue = currentValue || lastValue;

  return (
    <ListItemText
      primary={displayValue}
      sx={{ 
        textAlign: 'left', 
        fontSize: '0.85rem',
        color: isUsingLastValue ? 'rgba(0, 0, 0, 0.4)' : 'text.primary', // Lighter grey for last values
        ...props.sx
      }}
      {...props}
    />
  );
}; 